import React from "react";
import { Layers, Star, Zap, Headphones } from "lucide-react";
import { STATS } from "../mock";

const ICONS = [Layers, Star, Zap, Headphones];

export default function Stats() {
  return (
    <section className="bg-white pb-24 md:pb-32" data-testid="stats-section">
      <div className="container-x grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14">
        {STATS.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <div key={s.value} className="reveal flex flex-col items-center text-center">
              <Icon size={34} strokeWidth={1.4} className="text-[#0e0e0d]" />
              <p className="serif text-3xl md:text-4xl mt-5 text-[#0e0e0d]" style={{ fontWeight: 500 }}>
                {s.value}
              </p>
              <p className="text-sm text-[#5f5f59] mt-2 max-w-[200px]">{s.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
